//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { createFragmentContainer } from "react-relay";
// defrag daily results card imports
import { IProps, IState } from "./TailoredDefragSummaryEventsMovedList.d";
import { styles } from "./TailoredDefragSummaryEventsMovedList.styles";
import { fragments } from "./TailoredDefragSummaryEventsMovedList.gql";
import { TailoredDefragSummaryEventMoved } from "../tailored-defrag-summary-event-moved";
// material-ui
import { Button } from "@material-ui/core";
import { KeyboardArrowDown } from "@material-ui/icons";
import withStyles from "@material-ui/core/styles/withStyles";

//////////////////
// COMPONENT
//////////////////
class TailoredDefragSummaryEventsMovedListCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      overflowExpanded: false,
    };
  }

  private onToggleOverflow = () => {
    this.setState({ overflowExpanded: !this.state.overflowExpanded });
  };

  // ~-~-~-~-~-~-~-
  // Rendering
  // ~-~-~-~-~-~-~-
  public render() {
    // setup
    const { eventsMoved, rooms } = this.props;
    const { overflowExpanded } = this.state;
    // if > 2 meetings, split up into overflow section
    const hasOverflow = eventsMoved.length > 2;
    const firstEventsMoved = eventsMoved.slice(0, 2);
    const overflowEventsMoved = hasOverflow ? eventsMoved.slice(2, eventsMoved.length) : [];

    // compute a couple styles based on expansion state
    const overflowCount = overflowEventsMoved.length;
    const overflowLabel = overflowExpanded
      ? "Show fewer updates"
      : `${overflowEventsMoved.length} more updates`;
    const maxHeight = overflowExpanded ? `${overflowCount * 150}px` : 0;
    const overflowStyle = { ...styles.overflow, maxHeight };

    // and put it all together
    return (
      <div>
        {firstEventsMoved.map((eventMoved, i) => (
          <TailoredDefragSummaryEventMoved
            key={`set-one-${i}`}
            eventMoved={eventMoved}
            rooms={rooms}
          />
        ))}
        <div style={overflowStyle}>
          {overflowEventsMoved.map((eventMoved, i) => (
            <TailoredDefragSummaryEventMoved
              key={`set-two-${i}`}
              eventMoved={eventMoved}
              rooms={rooms}
            />
          ))}
        </div>
        {hasOverflow ? (
          <Button
            classes={{
              root: this.props.classes.overflowBtn,
              label: this.props.classes.overflowBtnLabel,
            }}
            onClick={this.onToggleOverflow}
            fullWidth
          >
            {overflowLabel}
            <KeyboardArrowDown style={overflowExpanded ? styles.btnIconExpanded : styles.btnIcon} />
          </Button>
        ) : (
          ""
        )}
      </div>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
export const TailoredDefragSummaryEventsMovedListStyled = withStyles(styles)(
  TailoredDefragSummaryEventsMovedListCmpt,
);

//////////////////
// RELAY
//////////////////
export const TailoredDefragSummaryEventsMovedList = createFragmentContainer(
  TailoredDefragSummaryEventsMovedListStyled,
  fragments,
);
